module.exports = __webpack_public_path__ + "img/Cards.639452bd.svg";